<script lang="ts">
	import { GlobalRoutes } from '#lib/features/navigation/constants/global-routes.js';
	import { HeniArtistsLogo } from '$global/assets/logos/HeniArtistsLogo';
	import { IconLink } from '$global/components/IconLink';
</script>

<IconLink
	dataCy="header"
	href={GlobalRoutes.ArtistsHome}
	label="See HENI Artists home page"
	class="outline-none"
>
	<HeniArtistsLogo color="gray-900" class="xs:scale-100 origin-left scale-75" />
</IconLink>
